import React, { useState, createContext, type ReactNode, useContext } from "react"
import { useTranslation } from "react-i18next"

interface ConfirmationContextData {
  hasNeedConfirmation: boolean
  messageConfirmation: string
  titleConfirmation: string
  setNewConfirmation: (title: string, message: string, e: () => void) => void
  disable: () => void
  action: (() => void) | undefined
}

const ConfirmationContext = createContext<ConfirmationContextData | undefined>(undefined)

interface ConfirmationProviderProps {
  children: ReactNode
}

export const ConfirmationProvider: React.FC<ConfirmationProviderProps> = ({ children }) => {
  const [hasNeedConfirmation, setHasConfirmation] = useState(false)

  const [messageConfirmation, setMessage] = useState("")

  const [titleConfirmation, setTitle] = useState("")

  const [action, setActione] = useState<() => void>()

  const setNewConfirmation = (title: string, message: string, e: () => void) => {
    setHasConfirmation(true)

    setMessage(message)

    setTitle(title)

    setActione(() => e)
  }

  const disable = () => {
    setHasConfirmation(false)
  }

  return (
    <ConfirmationContext.Provider
      value={{ action, hasNeedConfirmation, messageConfirmation, titleConfirmation, setNewConfirmation, disable }}
    >
      {children}
    </ConfirmationContext.Provider>
  )
}

export const useConfirmation = (): ConfirmationContextData => {
  const { t } = useTranslation("general")

  const context = useContext(ConfirmationContext)

  if (!context) {
    throw new Error(t("label_title_erro"))
  }

  return context
}

export {}
